import { createSelector } from 'reselect';
import _pick from 'lodash.pick';

export const summaryInfo = createSelector(
  state => state.professionalReport?.summary,
  summary => _pick(summary, ['rating'])
);
